export default __webpack_public_path__ + "static/media/ourclient9.1d91838b.png";